import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListHistory } from '../../store/thunk/setGetListHistory';
import HistoryItem from '../../components/historyItem';
import TemplatePage from '../../../components/templatePage';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const handleLoadPagination = ({page, setPage, countPage, dispatch}) => {
    if (page <= countPage) {
        dispatch(setGetListHistory({
            page: page + 1,
            rowsPerPage: 10
        }));
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const AdminHistory = () => {
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(1)

    React.useEffect(() => {
        dispatch(setGetListHistory({
            page: 1,
            rowsPerPage: 10
        }));
    }, [])

    const list = useSelector((state) => state.adminMobile.history);
   
    return (
        <TemplatePage
            title="История входов"
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage,
                dispatch
            })}
            handleLoading={() => handleLoading(dispatch)}
        >
            {
                list.data.map((item, key, array) => <HistoryItem 
                                                        item={item} 
                                                        keys={key} 
                                                        length={array.length} 
                                                    />)
            }
        </TemplatePage>

    )
}

export default AdminHistory;